<template>
  <a-form :form="form" @submit="submit" class="orderForm channelForm">
    <a-form-item
      v-bind="formItemLayout"
      v-for="(item,index) in orderParmas"
      :key="index"
      :label="item.label"
    >
      <div v-if="item.key == 'xcx_account' || item.key == 'xcx_password'">
        <a-input
          class="orderInput"
          :disabled="complete"
          :type="item.key == 'xcx_password'?'password':'text'"
          autocomplete="off"
          v-decorator="[item.key, { rules: [ {required: !cacheCilent, message: '请填写'+item.label}]}]"
        />
      </div>
      <div v-else-if="item.key == 'xcx_password'">
        <a-input
          class="orderInput"
          :disabled="complete"
          type="password"
          autocomplete="new-password"
          v-decorator="[item.key, { rules: [ {required: !cacheCilent, message: '请填写'+item.label}]}]"
        />
      </div>
      <div v-else-if="item.key=='xcx_banner'">
        <a-upload
          class="uploadItem"
          :beforeUpload="beforeUpload"
          accept=".png, .jpg, .jpeg"
          action="/api/workOrder/uploadImg"
          listType="picture-card"
          :fileList="item.value"
          @preview="handlePreview"
          @change="imgChangexcx_banner"
          v-decorator="[item.key]"
        >
          <div v-if="item.value.length < 1">
            <a-icon class="uploadplus" type="plus"/>
          </div>
        </a-upload>
        <div class="enter-tip">小程序banner图，建议尺寸：750*360，若无暂时不用上传</div>
      </div>
      <div v-else-if="item.key=='wx_qrcode'">
        <a-upload
          class="uploadItem"
          :beforeUpload="beforeUpload"
          accept=".png, .jpg, .jpeg"
          action="/api/workOrder/uploadImg"
          listType="picture-card"
          :fileList="item.value"
          @preview="handlePreview"
          @change="imgChangewx_qrcode"
          v-decorator="[item.key]"
        >
          <div v-if="item.value.length < 1">
            <a-icon class="uploadplus" type="plus"/>
          </div>
        </a-upload>
        <div class="enter-tip">客户个人微信二维码，建议尺寸：400*400，若无暂时不用上传</div>
      </div>
      <div v-else-if="item.key=='product_data'">
        <a-upload
          class="uploadItem"
          :beforeUpload="beforeUpload"
          accept=".png, .jpg, .jpeg"
          action="/api/workOrder/uploadImg"
          listType="picture-card"
          :fileList="item.value"
          @preview="handlePreview"
          @change="imgChangeproduct_data"
          v-decorator="[item.key]"
        >
          <div v-if="item.value.length < 10">
            <a-icon class="uploadplus" type="plus"/>
          </div>
        </a-upload>
        <div class="enter-tip">最多上传10张</div>
      </div>
      <div v-else-if="item.key=='xcx_template'">
        <a-upload
          class="uploadItem"
          :beforeUpload="beforeUpload"
          accept=".png, .jpg, .jpeg"
          action="/api/workOrder/uploadImg"
          listType="picture-card"
          :fileList="item.value"
          @preview="handlePreview"
          @change="imgChangexcx_template"
          v-decorator="[item.key]"
        >
          <div v-if="item.value.length < 1">
            <a-icon class="uploadplus" type="plus"/>
          </div>
        </a-upload>
        <div class="enter-tip">小程序意向模板图</div>
      </div>
    </a-form-item>
    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
      <img alt="example" style="width: 100%" :src="previewImage">
    </a-modal>
    <a-form-item :wrapper-col="{ span: 12, offset: 6 }">
      <a-button class="submit-btn" type="primary" html-type="submit">提交审核</a-button>
      <a-button
        v-if="!complete"
        class="temporary-btn"
        ghost
        data-cache="true"
        type="primary"
        @click="cacheCilentClick"
      >暂存</a-button>
    </a-form-item>
  </a-form>
</template>


<script>
const orderParmas = [
  {
    label: "小程序账号",
    key: "xcx_account",
    value: ""
  },
  {
    label: "小程序密码",
    key: "xcx_password",
    value: ""
  },
  {
    label: "小程序横幅",
    key: "xcx_banner",
    value: []
  },
  {
    label: "微信二维码",
    key: "wx_qrcode",
    value: []
  },
  {
    label: "产品资料",
    key: "product_data",
    value: []
  },
  {
    label: "意向模板",
    key: "xcx_template",
    value: []
  }
];

const formItemLayout = {
  labelCol: {
    xs: { span: 6 },
    sm: { span: 6 }
  },
  wrapperCol: {
    xs: { span: 18 },
    sm: { span: 18 }
  }
};
const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 24,
      offset: 0
    },
    sm: {
      span: 16,
      offset: 8
    }
  }
};
export default {
  props: ["complete", "order_id"],
  data() {
    return {
      formItemLayout,
      tailFormItemLayout,
      orderParmas,
      previewVisible: false,
      previewImage: "",
      hasSubmit: false,
      cacheCilent: false,
      imgUid: -1
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  created() {},
  mounted() {
    this.$nextTick(() => {
      this.getOrderInfo();
    });
  },
  methods: {
    //提交
    submit(e) {
      e.preventDefault();
      if (this.hasSubmit) return;
      this.orderParmas.map((v, k) => {
        if (v.key == "xcx_account" || v.key == "xcx_password") return;
        this.imgDataTreat(v);
      });
      let flag = true;
      let data = "";
      //必填项校验
      this.form.validateFieldsAndScroll(
        {
          scroll: {
            onlyScrollIfNeeded: true,
            offsetTop: 120
          }
        },
        (err, values) => {
          data = values;
          if (!err) {
            flag = false;
          }
        }
      );
      if (flag && !this.cacheCilent) {
        return;
      }
      //渠道注册
      data.client_data_type = 1;
      let url = this.cacheCilent
        ? "/api/WorkOrder/CacheCilent"
        : this.complete
        ? "/api/WorkOrder/EditCilent"
        : "/api/WorkOrder/clientCreate";
      data.order_id = this.order_id;
      axios({
        url: url,
        method: "POST",
        data: data
      })
        .then(res => {
          if (res.data.status == 0) {
            this.$router.push(`/myOrder`);
          }
          this.hasSubmit = false;
          this.cacheCilent = false;
        })
        .catch(err => {
          this.hasSubmit = false;
          this.cacheCilent = false;
        });
    },
    //暫存
    cacheCilentClick() {
      this.cacheCilent = true;
      document.querySelector(".channelForm .submit-btn").click();
    },
    //图片上传
    beforeUpload(file) {
      let flag = /^(.*)\.(png|jpg|jpeg)$/.test(file.name);
      return flag;
    },
    handleCancel() {
      this.previewVisible = false;
    },
    handlePreview(file) {
      this.previewImage = file.url || file.thumbUrl;
      this.previewVisible = true;
    },
    imgChangexcx_banner({ file, fileList }) {
      let flag = /^(.*)\.(png|jpg|jpeg)$/.test(file.name);
      if (!flag) {
        this.$message.error("请上传png，jpg，jpeg格式的文件");
        return;
      }
      this.orderParmas[2].value = fileList;
    },
    imgChangewx_qrcode({ file, fileList }) {
      let flag = /^(.*)\.(png|jpg|jpeg)$/.test(file.name);
      if (!flag) {
        this.$message.error("请上传png，jpg，jpeg格式的文件");
        return;
      }
      this.orderParmas[3].value = fileList;
    },
    imgChangeproduct_data({ file, fileList }) {
      let flag = /^(.*)\.(png|jpg|jpeg)$/.test(file.name);
      if (!flag) {
        this.$message.error("请上传png，jpg，jpeg格式的文件");
        return;
      }
      this.orderParmas[4].value = fileList;
    },
    imgChangexcx_template({ file, fileList }) {
      let flag = /^(.*)\.(png|jpg|jpeg)$/.test(file.name);
      if (!flag) {
        this.$message.error("请上传png，jpg，jpeg格式的文件");
        return;
      }
      this.orderParmas[5].value = fileList;
    },
    //处理图片数据
    imgDataTreat(imgData = {}) {
      let treatValue = imgData.value.map((v, k) => {
        return v.response ? v.response.data : v.url;
      });
      let params = {};
      params[imgData.key] =
        imgData.key == "product_data" ? treatValue : treatValue[0] || "";
      this.form.setFieldsValue(params);
    },
    //还原图片数据
    resetImgData(imgData = {}) {
      if (!imgData.urls) {
        this.orderParmas[imgData.key].value = [];
        return;
      }
      var fileList = [];
      if (imgData.urls.indexOf("[") + 1) {
        JSON.parse(imgData.urls).map((v, k) => {
          fileList.push({
            uid: this.imgUid--,
            url: v,
            name: `img${this.imgUid}.png`
          });
        });
      } else {
        fileList.push({
          uid: "" + this.imgUid--,
          url: imgData.urls,
          name: `img${this.imgUid}.png`
        });
      }
      this.orderParmas[imgData.key].value = fileList;
    },
    //完善资料 获取原数据
    getOrderInfo() {
      let url = this.complete
        ? "/api/WorkOrder/OrderDetail"
        : "/api/WorkOrder/OrderDetailCache";
      axios({
        url: url,
        method: "POST",
        data: {
          order_id: this.order_id
        }
      }).then(res => {
        let data = res.data.data;
        this.form.setFieldsValue({
          xcx_account: data.xcx_account,
          xcx_password: data.xcx_password
        });

        this.resetImgData({ key: 2, urls: data.xcx_banner });
        this.resetImgData({ key: 3, urls: data.wx_qrcode });
        this.resetImgData({ key: 4, urls: data.product_data });
        this.resetImgData({ key: 5, urls: data.xcx_template });
      });
    }
  }
};
</script>
<style scoped>
.orderForm {
  width: 675px;
}
.orderForm .orderInput {
  width: 330px;
  height: 40px;
  border-color: #dcdfe6;
}
.orderForm > .ant-form-item {
  margin-bottom: 20px;
}
.submit-btn,
.temporary-btn {
  border-radius: 16px;
}
.temporary-btn {
  margin-left: 20px;
}
.uploadplus {
  font-size: 30px;
  color: #cfcdcd;
}
.uploadItem .ant-upload-select-picture-card {
  background: #f8f9fb;
}
.enter-tip {
  width: 100%;
  color: #9fa5bb;
  font-size: 14px;
  display: flex;
  height: 1em;
  line-height: 1em;
}
.uploadItem >>> .ant-upload-list {
  float: none;
}
.ant-form-item-required:before {
  content: "·";
}
.orderForm >>> .ant-form-item-required::before {
  content: "·";
  color: #ff7200;
  font-size: 18px;
}
.orderForm >>> .ant-form-item-required::after,.orderForm>>>.ant-form-item-label label::after {
  margin-right: 20px;
}
</style>
